export const APP_ENV_SUBDOMAIN = process.env.REACT_APP_STAGE === 'dev' ? 'dev' : 'app';
